import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {JackpotBetPrizeContainerDefaultBox} from "./jp-bet-prize-container.default.box";
import {JackpotBetPrizeContainerMRGBox} from "./jp-bet-prize-container.mrg.box";
import {JackpotBetPrizeContainer777Box} from "./jp-bet-prize-container.777.box";

export const JackpotBetPrizeContainerBox = styledByTheme(JackpotBetPrizeContainerDefaultBox)
    .forMrGreen(JackpotBetPrizeContainerMRGBox)
    .forCasino777(JackpotBetPrizeContainer777Box)
    .apply();